<template>
  <div class="login-page">
    <div class="login-content">
      <div class="left">
        <!-- <img class="leftlogo" src="../../assets/rlogoleft.png" /> -->
      </div>
      <div class="right">
        <div class="tit-logo">
          <div class="logo"></div>
          <div class="tit">EBA签约平台</div>
        </div>
        <div class="Login">LOGIN</div>
        <div class="form-container">
          <a-form-model
            :hideRequiredMark="true"
            ref="loginForm"
            :rules="formRules"
            :model="formValues"
          >
            <a-form-model-item :colon="false" label="登陆账号" prop="userName">
              <a-input
                v-model="formValues.userName"
                placeholder="请输入用户名"
                size="large"
                v-on:keyup="formOnEnter"
              >
                <!-- <img slot="prefix" src="../../assets/loginuser.png" /> -->
              </a-input>
            </a-form-model-item>
            <a-form-model-item :colon="false" label="登陆密码" prop="memberPwd">
              <a-input-password
                v-model="formValues.memberPwd"
                placeholder="请输入密码"
                size="large"
                v-on:keyup="formOnEnter"
              >
                <!-- <img slot="prefix" src="../../assets/pass.png" /> -->
              </a-input-password>
            </a-form-model-item>
            <a-form-model-item>
              <a-button @click="onSubmit" size="large">登录</a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventStatusMixin from "../../mixins/eventStatus";
import { setToken } from "../../utils/tokenManager";
//import { login } from "./service";

export default {
  name: "Login",
  mixins: [eventStatusMixin],
  data() {
    return {
      formValues: {
        userName: "",
        memberPwd: "",
      },
    };
  },
  computed: {
    formRules() {
      return {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        memberPwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
      };
    },
  },
  methods: {
    formOnEnter(e) {
      if (e.keyCode === 13) return this.onSubmit();
    },
    onSubmit() {
      if (this.hasEventState("onSubmit")) return;
      this.addEventState("onSubmit");
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // const params = { ...this.formValues };
          // login
          //   .request(params)
          //   .then((result) => {
          //     if (result.bizCode === 1) {
          //       setToken(result.data.token);
          //       this.$router.replace("/app");
          //     } else this.$message.warning(result.bizRemind, 4);
          //   })
          //   .finally(() => {
          //     this.removeEventState("onSubmit");
          //   });
          setToken("123456");
          this.$router.replace("/app");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-page {
  width: 100vw;
  height: 100vh;
  > .login-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    // position: absolute;
    // z-index: 9999;
    // top: 25%;
    // left: 25%;
    // width: 800px;
    // height: 400px;
    // border-radius: 10px;
    // display: flex;
    > .left {
      width: 63%;
      height: 100%;
      background: #262934;
      display: flex;
      align-items: center;
      justify-content: center;
      > .leftlogo {
        width: 680px;
        height: 555px;
      }
    }
    > .right {
      width: 37%;
      height: 100%;
      background: #ffffff;
      padding: 64px 64px;
      > .tit-logo {
        display: flex;
        align-items: center;
        > .logo {
          width: 48px;
          height: 48px;
          background-image: url("../../assets/logo.png");
          background-size: 100% 100%;
        }
        > .tit {
          margin-left: 28px;
          font-size: 32px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 49px;
          color: #000000;
        }
      }
      > .Login {
        margin-top: 96px;
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 49px;
        color: #fe9d00;
      }
      > .form-container {
        margin-top: 90px;
        > .ant-form {
          > .ant-row {
            > .ant-col {
              > .ant-form-item-control {
                > .ant-form-item-children {
                  > .ant-input-affix-wrapper/deep/.ant-input:not(:first-child) {
                    padding-left: 40px;
                  }

                  > .ant-btn {
                    margin-top: 50px;
                    width: 200px;
                    border: 2px solid #fe9d00;
                    background: linear-gradient(
                      44deg,
                      #fcd03c 0%,
                      #feb200 100%
                    );
                    opacity: 1;
                    border-radius: 50px;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #ffffff;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
/deep/input {
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #cecece;
}
</style>
